import React, { useState, useEffect } from "react";
import "../Admin/UsuarioList.css";
import logo from "../Nido/logo.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Usuario from "../supabase/Usuario";
import ReviewModal from "./ReviewModal"

export default function History() {
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const [search, setSearch] = useState("");
    const [productos, setProductos] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    // Fetch all products on mount
    useEffect(() => {
        async function fetchData() {
            const data = await Usuario.getProducts(user.numDocumento);
            console.log(data);
            if (data) setProductos(data);
        }
        fetchData();

        if (selectedProduct) {
            // Disable scrolling
            document.body.style.overflow = "hidden";
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        } else {
            // Restore scrolling
            document.body.style.overflow = "auto";
        }

        // Cleanup on unmount
        return () => (document.body.style.overflow = "auto");
    }, [user, selectedProduct]);

    const handleLogout = () => {
        logout();
        navigate("/");
    };

    const filteredProductos = productos.filter((p) =>
        p.producto?.toLowerCase().includes(search.toLowerCase()) ||
        p.usuario?.toLowerCase().includes(search.toLowerCase())
    );

    const writeReview = () =>{

    }

    return (
        <div className="app-container">
            <header className="topbar">
                <div className="brand">
                    <img src={logo} alt="logo" className="brand-logo" />
                    <nav className="nav">
                        <button className="nav-link" onClick={() => navigate("/home")}>
                            Inicio
                        </button>
                        <button
                            className="nav-link active"
                            onClick={() => navigate("/profile")}
                        >
                            Mi nido
                        </button>
                    </nav>
                    <button
                        className="logout-btn"
                        onClick={handleLogout}
                        title="Cerrar sesión"
                    >
                        ↪
                    </button>
                </div>
                <title>ReANIDArt - Historial</title>
            </header>

            <div className="usuario-view-page">
                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Buscar productos o usuarios"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <button className="icon">🔍</button>
                </div>

                <main className="usuario-list">
                    {filteredProductos.length > 0 ? (
                        filteredProductos.map((producto) => (
                            <div className="usuario-card" key={producto.id}>
                                <div className="usuario-info">
                                    <div className="details">
                                        <span className="username">{producto.producto}</span>
                                        <span className="email">Vendedor: {producto.usuario}</span>
                                        <span className="email">Correo: {producto.correo} </span>
                                        <span className="telefono">Telefono: {producto.numtelefono} </span>
                                        <span className="review">
                                        {producto.resenna ? (
                                            producto.resenna
                                        ) : (
                                            <button
                                                className="btn"
                                                onClick={() => setSelectedProduct(producto)} // 👈 opens modal
                                            >
                                                Agrega una reseña y obtén ramitas
                                            </button>
                                        )}
                                      </span>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="no-results">No se encontraron productos.</p>
                    )}
                </main>
                {selectedProduct && (
                    <ReviewModal
                        producto={selectedProduct}
                        onClose={() => setSelectedProduct(null)}
                    />
                )}
            </div>
        </div>
    );
}
